import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export type GetPlantOverviewResponse = {
  totalYield: number;
  yieldToday: number;
  consumptionToday: number;
  selfConsumptionToday: number;

  //
  currentYieldPower: number;
  currentConsumptionPower: number;
  currentGridPower: number;
  currentBatteryPower: number;
  currentBatterySoC: number;

  currentPlantStatus: 0 | 1;
  mqttStatus: -1 | 0 | 1;
  //
  environmentalBenefits: {
    co2Reduction: number;
    treesPlanted: number;
    coalSavedTons: number;
  };
};

export const useGetPlantOverviewQuery = ({ plantId }: { plantId: string | undefined }) => {
  return useQuery({
    queryKey: ['plants', plantId, 'overview'],
    queryFn: async () => {
      const { data } = await client.get<GetPlantOverviewResponse>(
        `/plants/${plantId}/overview`
      );

      return data;
    },
    retry: 1,
    staleTime: 1000 * 30,
    refetchInterval: 1000 * 30,
    enabled: Boolean(plantId),
  });
};
